import React from 'react'
import TextFieldUniversal from '../../validate/form/text/TextFieldUniversal'
import { useState } from 'react'

const TextFieldMain = ({ 
	required, setValidate, setValueForm, forciblyValue, label = 'Текст', placeholder = 'Введіть текст', className, validates,
	multiline = false, rows = 1, onBlurMy
}) => {

    const [value, setValue] = useState('')

  return (
    <div className={className}>
		<TextFieldUniversal
			value={value}
			setValue={e => {
				setValueForm(e)
				setValue(e)
			}}
			setValidate={setValidate}
			label={label} 
			placeholder={placeholder}
			validates={{
				isEmpty: true,
				...validates
			}}
			forciblyValue={forciblyValue}
			required={required}
			onBlurMy={onBlurMy}
			multiline={multiline}
			rows={rows}
		/>
	</div>
  )
}

export default TextFieldMain